jQuery(document).ready(function($) {
    /* $('.work-samples .sample').on('click', function() {
        const elem = $(this)
        if(elem.hasClass('click-showing-text')) {
            elem.removeClass('click-showing-text')
            elem.removeClass('hover-showing-text')
        } else {
            elem.addClass('click-showing-text')
        }
    }) */

    $('.work-samples .sample').on('mouseenter', function() {
        $(this).addClass('hover-showing-text')
    })

    $('.work-samples .sample').on('mouseleave', function() {
        $(this).removeClass('hover-showing-text')
    })
})